<template>
    <div class="pl-5">
        <h1>OpenCart plugin</h1>
        <p style="font-style: italic; font-weight: bold;">NB! Opencart plugin was updated on 2021-09-20 to new v2 version. Please update your plugin if you have older version of Opencart plugin.</p>
        <p>
            Tarkpay offers a payment plugin for OpenCart. This plugin is developed for version 3+. Our payment plugin is
            developed only for EUR currency.<br />
            You can download the plugin:
            <a href="/static/opencart-plugin/tarkpay-opencart-payment.zip">here</a>
        </p>
        <p>
            1. The first step is to upload the plugin to root folder (making backup of your project is recommended).
            Take content from upload folder and paste it into your root folder where folders called "admin" and
            "catalog" are based. After that
        </p>
        <p>
            2. Go to your Admin panel and navigate to Extensions->Extensions.
        </p>
        <p>
            3. From filter search "Payments" and after that look for "TarkPay". <br />
            <img src="/static/img/opencart-1.png" />
        </p>
        <p>
            4. Click "Install" and after that "Edit" icon.
        </p>
        <p>
            5. Fill in following information from picture and insert your own company API key and Client ID. <br />
            <img src="/static/img/opencart-2.png" />
        </p>
        <p>
            6. Press "Save" icon from top and make test payment. Your checkout should look like: <br />
            <img src="/static/img/opencart-3.png" />
        </p>
    </div>
</template>

<script>
export default {
    name: "opencart-plugin-page"
};
</script>

<style scoped></style>
